export default "__VITE_ASSET__7JLiMnIv__"